import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]
  static values = {
    activeIndex: { type: Number, default: 0 }
  }

  connect() {
    this.showTab(this.activeIndexValue)
  }

  enter(event) {
    this.showTab(parseInt(event.currentTarget.dataset.index, 10))
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("accordion-tab-active", i === index)
    })
    this.activeIndexValue = index
  }
}
